import us from '../../../defines';

export function DragMomentum (viewport) {
  const self = this;
  const timerInterval = 20; // timer interval in milliseconds
  const damper = 0.8; // linear reduction on relative move
  const maxIterations = 15; // maximum number of momentum cycles

  let count = 0; // drag momentum cycle number
  let sweepX = 0;
  let sweepY = 0; // drag momentum distances

  self.go = function () {
    if (viewport.navModeGet() != us.eNavModes.nmNone) { // don't keep going if another nav mode has started
      return;
    }
    if (count === 0) { // if just starting momentum drag,
      const ptDelta = viewport.getMouseCurDiff(); // initialize the distance to move with the diffs between the last 2 cursor positions
      // insure that at least one iteration of drag momentum occurs (presumably will insure tile positions)
      sweepX = (ptDelta.x > 0) ? Math.max(ptDelta.x, 1) : Math.min(ptDelta.x, -1);
      sweepY = (ptDelta.y > 0) ? Math.max(ptDelta.y, 1) : Math.min(ptDelta.y, -1);
    } else {
      sweepX = parseInt(sweepX * damper, 10); // otherwise dampen the distance to move
      sweepY = parseInt(sweepY * damper, 10);
    }

    // if enough cycles have been performed or there isn't much of a move taking place, finsh
    // otherwise, move the image some more
    if (++count > maxIterations || ((Math.abs(sweepX) < 2) && (Math.abs(sweepY) < 2))) {
      count = sweepX = sweepY = 0; // reset momentum vars
    } else {
      viewport.moveRelative(sweepX, sweepY);
      setTimeout(self.go, timerInterval);
    }
  };
}
// ________________________________________________________________________________________________



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/DragMomentum.js